import { Box } from "@mui/material";
import { SettlementsList } from "Components/Settlements/SettlementsList";
import { MerchantDetailTransactionFees } from "Components/Transactions/UserTransactionFees/MerchantDetailTransactionFees";
import { SettlementDownloadSection } from "Components/Transactions/UserTransactionFees/SettlementDownloadSection";
import type { SettlementUserRole } from "Types/settlements";

type Props = {
  partyPublicID: string;
  userRole: SettlementUserRole;
};

export const MerchantTransactionFees = ({ partyPublicID, userRole }: Props) => (
  <>
    <MerchantDetailTransactionFees partyPublicID={partyPublicID} />
    <Box mt={2}>
      <SettlementDownloadSection
        partyPublicID={partyPublicID}
        userRole={userRole}
      />
    </Box>
    <Box mt={8}>
      <SettlementsList partyPublicID={partyPublicID} userRole={userRole} />
    </Box>
  </>
);
